import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "collapsible",
    "headerToggle",
    "headerToggleIcon",
    "anchor",
    "collapseDisplayable"
  ]

  connect() {
    this.#updateHeaderToggle(this.#isExpanded())
  }

  toggleCollapse() {
    const willCollapse = this.#isExpanded()
    this.element.classList.toggle("is-collapsed", willCollapse)
    let elementsForCollapse, elementsForDisplay

    if (willCollapse) {
      elementsForCollapse = this.collapsibleTargets
      elementsForDisplay = this.collapseDisplayableTargets
    } else {
      elementsForDisplay = this.collapsibleTargets
      elementsForCollapse = this.collapseDisplayableTargets
    }

    elementsForCollapse.forEach(el => {
      el.classList.remove('d-none')
      el.classList.toggle('is-collapsing', true)
    })
    elementsForDisplay.forEach(el => {
      el.classList.toggle('is-collapsing', false)
      el.classList.toggle('d-none', false)
    })

    setTimeout(() => {
      elementsForCollapse.forEach(el => {
        el.classList.toggle('d-none', true)
        el.classList.toggle('is-collapsing', false)
      })
    }, 250)

    this.#updateHeaderToggle(!willCollapse)
    this.scrollToAnchor()
  }

  #isExpanded() {
    return this.collapsibleTargets.some(el => !el.classList.contains('d-none'))
  }

  scrollToAnchor() {
    if (this.hasAnchorTarget) {
      const top = this.anchorTarget.getBoundingClientRect().top + window.scrollY
      window.scrollTo({top: top - 70, behavior: 'smooth'})
    }
  }

  #updateHeaderToggle(isOpen) {
    if (this.hasHeaderToggleTarget) {
      this.headerToggleTarget.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
      this.headerToggleTarget.setAttribute('aria-label', isOpen ? 'Collapse step' : 'Expand step')
    }
    if (this.hasHeaderToggleIconTarget) {
      const icon = this.headerToggleIconTarget
      icon.classList.toggle('bi-chevron-down', isOpen)
      icon.classList.toggle('bi-chevron-right', !isOpen)
    }
  }
}
